import { Check } from 'lucide-react'

export function Features() {
  const features = [
    {
      category: 'Order Management',
      items: [
        'Real-time order tracking',
        'Status updates & notifications',
        'Multi-channel order sync',
        'Order history & analytics'
      ]
    },
    {
      category: 'Catalog Management',
      items: [
        'Product & service management',
        'Variant support (size, color, etc.)',
        'Inventory tracking',
        'Bulk import/export'
      ]
    },
    {
      category: 'Customer Management',
      items: [
        'Customer profiles & history',
        'Loyalty programs',
        'Customer segmentation',
        'Communication tools'
      ]
    },
    {
      category: 'Multi-tenant Platform',
      items: [
        'Custom branding per tenant',
        'Isolated data & security',
        'Flexible pricing plans',
        'White-label options'
      ]
    }
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-neutral-900 mb-4">Features</h1>
          <p className="text-xl text-neutral-600">
            Everything you need to run your business online
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="bg-neutral-50 p-8 rounded-xl">
              <h2 className="text-2xl font-semibold text-neutral-900 mb-4">{feature.category}</h2>
              <ul className="space-y-3">
                {feature.items.map((item, itemIdx) => (
                  <li key={itemIdx} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-success-500 flex-shrink-0 mt-0.5" />
                    <span className="text-neutral-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
  )
}

